export default __webpack_public_path__ + "static/media/login-img.a6117a8d.png";